import { createRoutine } from 'redux-saga-routines';
import { AUTH_LOGIN_SSO, AUTH_LOGOUT, AUTH_REFRESH_TOKEN } from './types';

export const authLoginSSO = createRoutine(AUTH_LOGIN_SSO);
export const authLogout = createRoutine(AUTH_LOGOUT);
export const authRefreshToken = createRoutine(AUTH_REFRESH_TOKEN);
